import React, { useEffect, useState, useMemo } from "react";
import { FormWrapperItem, ListComponent } from "../../../../common/component/Index";
import { Skeleton } from 'antd';
import { Package } from "../../../../../../models/Reservation";
import * as Func from '../../../../../../helpers/functions';
import { get } from "lodash";
import i18n from "../../../../../../constants/initLng";
import Span from "../../../../common/component/Span";

const ReservationsTableKeys = [
    'product',
    'ratePlan',
    'bookable',
    'quantity',
    'amount',
    'original_amount',
    "interest_amount",
    'sale_amount',
    'total_amount',
];
const modelKeys = Object.getOwnPropertyNames(new Package());

const PackageRatesList = (props) => {
    const { reservations, loading, t } = props;
        const [packageRates, setPackageRates] = useState([]);
        const [titleTable] = useState(Func.getTitleTable([...ReservationsTableKeys], [], ['amount']));
        const componentTable = useMemo(() =>
            ({
                product: {
                    render: (text, item) => {
                        return (item.packageRateBookableProducts || []).map(x=><div>{x.name}</div>);
                    }
                },
                ratePlan: {
                    render: (text, item) => {
                        return item.packageRatePlanProduct?.name;
                    }
                },
                bookable: {
                    render: (text, item) => {
                        const bookablesCodeV1 = (item.packageRateBookableProducts || []).map(x => x.code).join(" ,");
                        const bookablesCodeV2 = (item.packageRateBookableProducts || []).map(x => <div>{x.code}</div>)
                        return item.isV2 ? bookablesCodeV2 : bookablesCodeV1;
                    }
                },
                quantity: {
                    align: "right",
                    render: (text, item) => {
                        const quantityV2 = (item.packageRateBookableProducts || []).map(x => <div>{x.quantity}</div>)
                        return item.isV2 ? quantityV2 : item.quantity;
                    }
                },
                original_amount: {
                    align: "right",
                    render: (text, item) => {
                        const originAmountV1 = renderPrices(
                            totalOriginalAmount(item) || 0,
                            i18n.t(`currencySymbol`), true
                        );
                        const originAmountV2 = originalAmount(item).map(x => (
                            <div>
                                {renderPrices(x || 0, i18n.t(`currencySymbol`), true)}
                            </div>
                        ))
                        return item.isV2 ? originAmountV2 : originAmountV1
                    }
                },
                interest_amount: {
                    align: "right",
                    render: (text, item) => {
                        const markupPriceV1 = renderPrices(
                            totalMarkUpPrice(item) || 0,
                            i18n.t(`currencySymbol`), true
                        );
                        const markupPriceV2 = interestAmount(item).map(x =>
                            <div>
                                {renderPrices(x || 0, i18n.t(`currencySymbol`), true)}
                            </div>
                        )
                        return item.isV2 ? markupPriceV2 : markupPriceV1
                    }
                },
                sale_amount: {
                    align: "right",
                    render: (text, item) => {
                        const saleAmountV1 = renderPrices(
                            totalOriginalAmount(item) + totalMarkUpPrice(item),
                            i18n.t(`currencySymbol`), true
                        )
                        const saleAmountV2 = salelAmount(item).map(x => (
                            <div>
                                {renderPrices(x || 0, i18n.t(`currencySymbol`), true)}
                            </div>
                        ))
                        return item.isV2 ? saleAmountV2 : saleAmountV1
                    }
                },
                total_amount: {
                    align: "right",
                    render: (text, item) => {
                        const originAmount = totalOriginalAmount(item);
                        const markupPrice = totalMarkUpPrice(item);
                        const quantity = item.quantity || 0;
                        const totalAmountV1 = renderPrices(quantity * (originAmount + markupPrice), i18n.t(`currencySymbol`), true);
                        const totalAmountV2 = totalAmount(item).map(x => (
                            <div>
                                {renderPrices(x || 0,i18n.t(`currencySymbol`),true)}
                            </div>
                        ))
                        return item.isV2 ? totalAmountV2 : totalAmountV1;
                    }
                },
            }), [reservations]
        )

        useEffect(() => {
            const newPackageRates = (reservations || []).filter(x=>!!x.packages).map(x=> x.packages).flat();
            setPackageRates(newPackageRates);
        }, [reservations])

        const originalAmount = (item) => {
            return (get(item, 'packageRateBookableProducts', [])).map(x => (x.amount / x.quantity));
        }

        const interestAmount = (item) => {
            return (get(item, 'packageRateBookableProducts', [])).map(x => (x.markUpPrice / x.quantity));
        }

        const salelAmount = (item) => {
            return (get(item, 'packageRateBookableProducts', [])).map(x => ((x.amount + x.markUpPrice) / x.quantity));
        }

        const totalAmount = (item) => {
            return (get(item, 'packageRateBookableProducts', [])).map(x => (x.amount + x.markUpPrice));
        }

        const totalOriginalAmount = (item) => {
            return (get(item, 'packageRateBookableProducts', [])).reduce((prevVal, currVal) => prevVal + currVal.amount, 0);
        }

        const totalMarkUpPrice = (item) => {
            return (get(item, 'packageRateBookableProducts', [])).reduce((prevVal, currVal) => prevVal + currVal.markUpPrice, 0);
        }

        const renderPrices = (price, currency, quantity) => {
            return (
                <Span className="prices">
                    {quantity && <Span>{quantity > 1 ? `${quantity}x` : ''}{Func.formatMoney(price)}</Span>}{`${currency || ''}`}
                </Span>
            )
        }

        return (
            <>
                {
                    packageRates?.length > 0 && (
                        <>
                            <h3 className="ml-0 my-3">Thông tin Package Rate</h3>
                            <FormWrapperItem classParent="p-0 m-0 no-border" classChildren="m-0 p-0">
                                {!loading ?
                                    <ListComponent
                                        classParent="m-0 p-0 col-md-12"
                                        classChildren="p-0 m-0"
                                        marginTop={'0'} marginBottom={'0'}
                                        loading={{ spinning: loading, size: 'large' }}
                                        rowKey={(record, k) => k}
                                        dataSource={Func.getDataSource(packageRates || [], modelKeys)}
                                        columns={Func.columnsTable({ titleTable: titleTable, component: componentTable, itemName: 'order.packageRates' })}
                                        componentTableList={{}}
                                    />
                                    : <Skeleton active paragraph={{ row: 3 }} className="p-4" />
                                }
                            </FormWrapperItem>
                        </>
                    )
                }
            </>
        )
}

export default PackageRatesList;